import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { ILaboratoryStudents } from "./routeType";

import type { IPickMutation } from "@/api";
import { getApi } from "@api/apiPath";
import { axiosClient, queryClient } from "@api/clients.ts";
import { useGetAllMemberLaboratoryStudents } from "@/api/members/laboratories/students/getAll";
import { useGetMemberLaboratoryStudent } from "@/api/members/laboratories/students/get";

const { getPath } = getApi("members.laboratories.students.post");

type IExtractedRouteType = ILaboratoryStudents["laboratoryStudentSingleCreate"];

export type IPostMemberLaboratoryStudent = IPickMutation<IExtractedRouteType>;

const postMemberLaboratoryStudent: MutationFunction<
  IPostMemberLaboratoryStudent["response"],
  IPostMemberLaboratoryStudent["variables"]
> = ({ labId, ...data }) => {
  return axiosClient.post(getPath({ labId }), data);
};

export const usePostMemberLaboratoryStudent = createMutation({
  mutationFn: postMemberLaboratoryStudent,
  onSuccess: (_, { labId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberLaboratoryStudents.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberLaboratoryStudent.getKey({ labId }),
    });
  },
});
